
import React from "react";
import {transactionSelling} from "../Const/TranscationCode";

const LabelSelling=(props)=>{
    const filter=transactionSelling.filter((item)=>item.key===props.value);
    if(filter.length==1){
        return <div className={"badge badge-light-" + (filter[0].color)}>{(filter[0].label)}</div>
    }   
    return ''
}
export default LabelSelling;